import React__default from 'react';
import { Typography, Box } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import KButtonAction from '../../KButtons/KButtonAction/index.js';
import StyledActiveFilter, { classes } from './index.styled.js';

var ActiveFilter = function (_a) {
    var filter = _a.filter, valuesComponent = _a.valuesComponent, onFilterDelete = _a.onFilterDelete, sx = _a.sx, className = _a.className, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(StyledActiveFilter, { sx: sx, className: clsx("ActiveFilter", className) },
        React__default.createElement("div", { className: classes.details },
            React__default.createElement("div", { className: classes.filter },
                React__default.createElement(Typography, { className: classes.filterType, variant: "caption", component: "div" }, filter.label),
                React__default.createElement(Box, { className: classes.filterValues }, valuesComponent))),
        React__default.createElement(KButtonAction, { onClick: function () {
                if (onFilterDelete) {
                    onFilterDelete(filter);
                }
            }, "aria-label": t("components.active-filters.remove.label"), actionButtonName: "deleteFilter", title: t("components.active-filters.remove.label"), "data-testid": "deleteFilterButton", className: classes.closeButton },
            React__default.createElement(KIcon, { fontSize: "small", className: "fa-solid fa-xmark", sx: { fontSize: "0.8rem" } }))));
};

export { ActiveFilter as default };
//# sourceMappingURL=index.js.map
